<template>
  <div class="section has-text-centered">
    <p class="title is-4">
      Choose the location you are visiting to access the correct waiver!
    </p>
    <div class="py-5">
      <div class="is-hidden-mobile is-hidden-touch">
        <div
          v-for="(item, index) in shopList"
          :key="index"
          :class="index == 0 ? '' : 'mt-5'"
        >
          <a
            @click="goLink(citem)"
            v-for="(citem, cindex) in item"
            class="tag is-primary is-large is-rounded has-text-weight-semibold"
            :style="{ marginRight: cindex == item.length - 1 ? '' : '6px' }"
            :key="cindex"
          >
            <img
              class="fas fa-map-marker-alt mr-2 local-img"
              src="../../../assets/img/local.png"
            />
            {{ citem.name }}
          </a>
        </div>
      </div>
      <div class="is-hidden-desktop">
        <div
          v-for="(item, index) in shopListMobile"
          :key="index"
          :class="index == 0 ? '' : 'mt-5'"
        >
          <a
            @click="goLink(item)"
            class="tag is-primary is-large is-rounded has-text-weight-semibold"
            :style="{ marginRight: index == item.length - 1 ? '' : '6px' }"
          >
            <img
              class="fas fa-map-marker-alt mr-2 local-img"
              src="../../../assets/img/local.png"
            />
            {{ item.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    shopList() {
      var data = store.state.global.shopLists;
      var result = [];
      for (var i = 0; i < data.length; i += 3) {
        result.push(data.slice(i, i + 3));
      }
      return result;
      // return store.state.global.shopLists || [];
    },
    shopListMobile() {
      return store.state.global.shopLists || [];
    },
  },
  created() {},
  methods: {
    goLink(item) {
      var path = this.$route.path;
      window.location.href = `https://${item.domain}${path}`;
    },
  },
};
</script>
<style scoped>
.policy-head {
  background-color: #f5d784;
  margin: 0 auto;
  margin-top: 50px;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
  margin: auto;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container {
    max-width: 1344px;
  }
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.columns.is-vcentered {
  align-items: center;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.title,
.subtitle {
  word-break: break-word;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
  .columns:not(.is-desktop) {
    display: flex;
  }
  .is-hidden-tablet {
    display: none !important;
  }
}
.section {
  padding: 3rem 1.5rem;
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
}
@media screen and (max-width: 1023px) {
  .is-hidden-touch {
    display: none !important;
  }
}

@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
  .is-hidden-desktop {
    display: none !important;
  }
  .columns.is-desktop {
    display: flex;
  }
  .section {
    padding: 3rem;
  }
}

.has-text-centered {
  text-align: center !important;
}

.py-5 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.tag {
  cursor: pointer;
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 1.25rem;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.has-text-white {
  color: #fff !important;
}
.fas,
.fa-solid {
  font-weight: 900;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.is-4 {
  font-size: 1.5rem;
}
.local-img {
  max-width: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/policy/components/ParentWaiver.vue